import { useCurrentUser } from "@qualio/ui-components";
import { useCurrentProduct } from "../useCurrentProduct";
import { useQuery } from "react-query";
import { designControlsApi } from "../../api/designControls";

export const useTraceability = () => {
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();

  return useQuery({
    queryFn: () => {
      return designControlsApi.traceabilityMatrix(companyId, productId, 500);
    },
    queryKey: ["TRACEABILITY", companyId, productId],
  });
};
